<template>
  <div class="home">
    <div class="img_box">
      <img src="../assets/images/Font_logoW@2x.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="less">

@import "../../static/Adaptive/home.less";
</style>



// WEBPACK FOOTER //
// src/components/home.vue